export const springSnap   = { type: "spring", stiffness: 500, damping: 30 };
export const springBounce = { type: "spring", stiffness: 300, damping: 20 };
export const fadeIn       = { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 } };
export const slideInRight = { initial: { x: 60, opacity: 0 }, animate: { x: 0, opacity: 1 } };
export const slideInUp    = { initial: { y: 30, opacity: 0 }, animate: { y: 0, opacity: 1 } };
export const shake        = { x: [0, -8, 8, -6, 6, 0], transition: { duration: 0.4 } };
export const pulse        = { scale: [1, 1.05, 1], transition: { duration: 0.6, repeat: Infinity } };
